import React from "react";
import { notification } from "antd";
import isEmpty from "lodash/isEmpty";
import has from "lodash/has";
import get from "lodash/get";
import { selectedPolygonTypes, Tenant as availableTenants } from "./Constants";
import { pick, unset } from "lodash";
import userServices from "../../UserServices/UserServices";
const obj = {
	getBooleanVale: (object, value, DEFAULT) => {
		return has(object, value) ? get(object, value) : DEFAULT;
	},
	FindCenter: arr => {
		var x = arr.map(([lng]) => lng);
		var y = arr.map(([, lat]) => lat);
		var lng = (Math.min(...x) + Math.max(...x)) / 2;
		var lat = (Math.min(...y) + Math.max(...y)) / 2;
		return { lng, lat };
	},
	FormateNumber: num => {
		num = num || 0;
		return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
	},
	NotSupported: () => {
		const openNotification = () => {
			notification.warning({
				message: "Warning",
				description: "This Functionality is not supported Yet."
			});
		};
		return openNotification();
	},
	Error: description => {
		const openNotification = () => {
			notification.error({
				message: "Error",
				description,
				duration: 3
			});
		};
		return openNotification();
	},
	Warning: description => {
		const openNotification = () => {
			notification.warning({
				message: "Warning",
				description,
				duration: 4
			});
		};
		return openNotification();
	},
	Info: description => {
		const openNotification = () => {
			notification.info({
				message: "Info",
				description,
				duration: 2
			});
		};
		return openNotification();
	},
	clearEmptyObjects: obj => {
		Object.keys(obj).forEach(key => {
			if (
				// obj[key] === null ||
				obj[key] === undefined ||
				(typeof obj[key] === "string" &&
					(obj[key].toLowerCase() === "no" || obj[key].toLowerCase() === "ignore")) ||
				obj[key] === "" ||
				(Array.isArray(obj[key]) && obj[key].length === 0) ||
				(typeof obj[key] === "object" && isEmpty(obj[key]))
			) {
				delete obj[key];
			}
		});
		return obj;
	},

	clearEmptyShopsData: obj => {
		Object.keys(obj).forEach(key => {
			if (
				obj[key] === null ||
				obj[key] === undefined ||
				(typeof obj[key] === "string" &&
					(obj[key].toLowerCase() === "no" || obj[key] === "" || obj[key] === "Not_Available")) ||
				(Array.isArray(obj[key]) && obj[key].length === 0)
			) {
				delete obj[key];
			}
		});
		return obj;
	},

	getTitle: Title => <h4>{Title}</h4>,
	getSelectedPolygons: _polygons => {
		return _polygons.filter(({ style: { fillColor } }) => fillColor.endsWith("ff"));
	},
	getPolygon: ({ _id, coordinates, center, sub_areas, type, parent_area, name }) => {
		if (Array.isArray(coordinates)) {
			coordinates = coordinates[0].map(([lng, lat]) => {
				return { lat, lng };
			});
		}
		return {
			id: _id,
			name,
			_id,
			center,
			sub_areas,
			coordinates,
			type,
			parent_area,
			style: {
				fillColor: "#8ccdfc96",
				strokeColor: "#000000"
			},
			showInfo: false,
			polygonClick: true
		};
	},
	getLegend: ({ text, color, icon, onClick }) => {
		return (
			<span
				key={`google_legend_`}
				style={{
					width: "max-content",
					"font-size": "11px",
					padding: "2px 4px",
					border: "1px solid transparent",
					margin: "5px 3px 0px",
					display: "inline-flex",
					"align-items": "center",
					"background-color": "rgba(0, 0, 0, 0.65)",
					color: "white"
				}}
				onClick={onClick ? onClick : () => {}}
			>
				{color && (
					<span
						style={{
							width: "10px",
							height: "10px",
							display: "inline-flex",
							"margin-right": "6px",
							"background-color": color
						}}
						span
					/>
				)}
				{icon && (
					<span
						style={{
							width: "max-content",
							border: "1px solid transparent",
							margin: "0px 3px 0px",
							display: "inline-flex",
							"align-items": "center"
						}}
					>
						<img className="manImg" src={icon} alt="No Source"></img>
					</span>
				)}
				{text}
			</span>
		);
	},

	formatString: str => {
		if (typeof str !== "string") return str;
		if (str.startsWith("rgba")) return str;
		if (str === "name") return str;
		return str
			.replace(/_/g, " ")
			.replace(/\b\w/g, c => c.toUpperCase())
			.trim()
			.replace(/([a-z])([A-Z])/g, "$1 $2");
	},
	getTenantName: name => {
		if (name === "JAZZCASH") return "Clients";
		return Tenant[name] || name;
	},
	getCensusNameMapping: name => {
		return CensusNameMapping[name] || "Census Shops";
	},
	modifyFilterObjectForQuery: Filters => {
		Object.entries(Filters).forEach(([k, v]) => {
			if (isObject(v) && (isEmpty(v) || Object.values(v).length <= 1)) {
				unset(Filters, k);
			}
		});
		return Filters;
	}
};

export default obj;

const { getTenantName } = obj;
const getDisableFlag = selectedPolygons => {
	const {
		defaultpolygons,
		CELLSITES,
		SAWhiteSpace,
		PopulationGrids,
		Expansion,
		DailyTrafficData,
		demographicPopulationDensity,
		SecPolgons,
		// motor_spots,
		whiteSpace_density,
		sec_density
	} = selectedPolygonTypes;
	return ![
		CELLSITES,
		defaultpolygons,
		SAWhiteSpace,
		PopulationGrids,
		Expansion,
		DailyTrafficData,
		demographicPopulationDensity,
		SecPolgons,
		// motor_spots,
		whiteSpace_density,
		sec_density
	].includes(selectedPolygons);
};
const isObject = value => {
	return typeof value === "object" && value !== null && !Array.isArray(value) && !(value instanceof String);
};
const Tenant = {
	EBM_REGIONAL: "EBM Shpos",
	ISMAIL_INDUSTRIES: "Client Shpos",
	BAT_UK: "BAT-UK Shpos",
	BAT_UK_INDEPENDENT: "BAT-UK-INDEPENDENT Shpos",
	NIElSEN_DEMO: "Client Shpos",
	BAT_SOUTH_KOREA: "Naver Shpos",
	BAT_ROMANIA_V2: "Existing Shpos",
	BAT_TENNESSEE: "TDLinx Outlets",
	BAT_FLORIDA: " TDLinx Outlets",
	RB_PAKISTAN_V2: "Rb Pakistan",
	BAT_NAIROBI: "RB_Nairobi",
	BAT_JAPAN: "BAT Outlet",
	BAT_STATES: "TDLinx Outlets",
	UL_INDONESIA: "Covered Stores"
};
const CensusNameMapping = {
	BAT_ROMANIA_V2: "Additional Shops",
	BAT_TENNESSEE: "Census Outlets",
	BAT_SWITZERLAND: "Outlets",
	// BAT_JAPAN: "Smoking Areas"
	BAT_JAPAN: "HoReCa (Smoking & non smoking) & Other Smoking Zones"
};
const formateString = key => {
	return key
		.replace(/_/g, " ")
		.replace(/\b\w/g, c => c.toUpperCase())
		.trim()
		.replace(/([a-z])([A-Z])/g, "$1 $2");
};

export const getPerCapita = (tableData, tenant) => {
	const population = get(tableData, "population", 0);

	// census_per_capita
	let census_per_capita = 0;
	const filtered_shops = get(tableData, "filtered_shops", 0);
	const census_shops = get(tableData, "census_shops", 0);

	if (filtered_shops > 0) {
		census_per_capita = (population / filtered_shops).toFixed(2);
	} else if (census_shops > 0) {
		census_per_capita = (population / census_shops).toFixed(2);
	}

	// client_shops
	let client_per_capita = 0;
	const client_shops = get(tableData, "client_shops", 0);
	let client_filtered_shops = get(tableData, `${getTenantName(tenant)} Selected`, 0);

	if (client_filtered_shops > 0) {
		client_per_capita = (population / client_filtered_shops).toFixed(2);
	} else if (client_shops > 0) {
		client_per_capita = (population / client_shops).toFixed(2);
	}

	return {
		census_per_capita: Number(census_per_capita).toFixed(0),
		client_per_capita: Number(client_per_capita).toFixed(0)
	};
};

export const getPerCapitaByPolygon = tableData => {
	const population = get(tableData, "population", 0);

	// census_per_capita
	let census_per_capita = 0;
	const census_shops = get(tableData, "census_shops", 0);

	if (census_shops > 0) {
		census_per_capita = (population / census_shops).toFixed(2);
	}

	// client_shops
	let client_per_capita = 0;
	const client_shops = get(tableData, "client_shops", 0);

	if (client_shops > 0) {
		client_per_capita = (population / client_shops).toFixed(2);
	}

	return {
		census_per_capita: Number(census_per_capita).toFixed(0),
		client_per_capita: Number(client_per_capita).toFixed(0)
	};
};

const dropdownHierarchyType = () => {
	const { BAT_FLORIDA, BAT_STATES } = availableTenants;

	const { tenant } = pick(userServices.getCurrentUser(), ["tenant"]);

	return [BAT_FLORIDA, BAT_STATES].includes(tenant);
};

export { getDisableFlag, formateString, dropdownHierarchyType };
